window.soanFlyToCart = function(sourceEl) {
  try {
    var target = document.querySelector('#cart-icon-bubble') || document.querySelector('a[href="' + (window.routes ? window.routes.cart_url : '/cart') + '"]');
    if (!target || !sourceEl) return;

    var sourceRect = sourceEl.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();

    var startX = sourceRect.left + sourceRect.width / 2;
    var startY = sourceRect.top + sourceRect.height / 2;
    var endX = targetRect.left + targetRect.width / 2;
    var endY = targetRect.top + targetRect.height / 2;

    var dot = document.createElement('div');
    dot.className = 'soan-fly-dot';
    dot.textContent = '🛍️';
    dot.style.cssText = [
      'position:fixed',
      'top:' + (startY - 15) + 'px',
      'left:' + (startX - 15) + 'px',
      'width:30px',
      'height:30px',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'font-size:16px',
      'line-height:1',
      'background:#1A1A1A',
      'color:#C9A84C',
      'border:1px solid #C9A84C',
      'border-radius:50%',
      'z-index:99999',
      'pointer-events:none',
      'transition:transform 0.65s cubic-bezier(0.55,-0.15,0.7,0.4), opacity 0.65s ease',
      'box-shadow:0 4px 12px rgba(0,0,0,0.3)'
    ].join(';');
    document.body.appendChild(dot);

    var deltaX = endX - startX;
    var deltaY = endY - startY;

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        dot.style.transform = 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.25)';
        dot.style.opacity = '0.2';
      });
    });

    setTimeout(function() {
      if (dot.parentNode) dot.parentNode.removeChild(dot);
      target.classList.add('soan-cart-bump');
      setTimeout(function() { target.classList.remove('soan-cart-bump'); }, 300);
    }, 680);
  } catch (e) {}
};
